/* eslint-disable react/jsx-props-no-spreading */
import { Chakra } from "@airhelp/react-ui-components";
import NextLink from "next/link";
import { useExtendedRouter } from "hooks";
import { useTranslations } from "contexts/LocalizationContext";
import PropTypes from "prop-types";

const { Link } = Chakra;

const MenuLink = ({ menuItem, linkType, ...props }) => {
  const translations = useTranslations();
  const { label, href, attributes = {}, prefetch = false, icon, dataQA } = menuItem;
  const { target, rel } = attributes;

  const { asPath: pagePath } = useExtendedRouter();
  const linkFontWeight = pagePath === `${href}/` ? "medium" : "normal";

  const Icon = icon;

  const linkComponent = (
    <Link
      fontWeight={linkFontWeight}
      sx={{ svg: { boxSize: 3 } }}
      role="menuitem"
      as={linkType}
      key={label}
      href={href}
      target={target}
      rel={rel}
      data-testid={dataQA}
      {...props}
    >
      {translations(label)}
      {icon && <Icon boxSize={3} ml={2} display={{ base: "none", lg: "inline" }} />}
    </Link>
  );

  if (prefetch) {
    return (
      <NextLink href={href} passHref>
        {linkComponent}
      </NextLink>
    );
  }

  return linkComponent;
};

export default MenuLink;

MenuLink.propTypes = {
  menuItem: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string,
    attributes: PropTypes.shape({}),
    isNext: PropTypes.bool,
  }).isRequired,
  linkType: PropTypes.string,
};

MenuLink.defaultProps = {
  linkType: "",
};
